import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';


const Proccess = ({ size }) => {

  return (
    <Box
      sx={{
        textAlign: 'center',
        alignContent: 'center',
        height: size === "large" ? '33vh' : '30vh',
      }}>
      <CircularProgress />
    </Box>
  )
}

export default Proccess;